import React, { useState } from 'react';

import { Box, MenuItem, Select, FormControl, InputLabel, Button } from '@mui/material';

export default function PrivacyFieldSelector({ auditType, privacyFieldsDictionary, onAdd }) 
{
  
    const [selectedFieldId, setSelectedFieldId] = useState('');

    const handleChange = (event) => {
        setSelectedFieldId(event.target.value);
    };

    const handleAddClick = () => {
        if (selectedFieldId) {
            onAdd(auditType, selectedFieldId);
            setSelectedFieldId(''); // reset after add
        }
    };

    const fieldsForAuditType = privacyFieldsDictionary?.[auditType];

    return (
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 1, mt: 1, width: '100%' }}>
        <FormControl size="small" sx={{ minWidth: 0, width: { xs: '100%', sm: 200 } }}>
            <InputLabel>Select Field</InputLabel>
            <Select
            value={selectedFieldId}
            onChange={handleChange}
            label="Select Field"
            >
            {fieldsForAuditType &&
            Object.entries(fieldsForAuditType)
                .sort(([, a], [, b]) => a.fieldName.localeCompare(b.fieldName))
                .map(([fieldId, field]) => (
                <MenuItem key={fieldId} value={fieldId}>
                    {field.fieldName}
                </MenuItem>
            ))}
            </Select>
        </FormControl>
        <Button
            size="small"
            sx={{ width: { xs: '100%', sm: 'auto' } }}
            onClick={handleAddClick}
            disabled={!selectedFieldId}
        >
            Add
        </Button>
        </Box>
    );
    
}
